import { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { format, startOfMonth } from "date-fns";

import TitlePage from "../../../components/TitlePage";
import ResponsiveDataTable from "../../../components/DataTable";
import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";
import ExportarExcel from "../../../components/ExportarExcel";

import { useSessionStorageState } from "../../../../hooks/useSessionStorageState";
import { ErroMsg } from "../../../contents/VariaveisGlobais";
import { ConsultaAPI_URL } from "../../../../backend/ConsultaAPI";


function LogAprovacaoV360() {

    const currentDate = new Date();
    const firstDayOfMonthDate = startOfMonth(currentDate);

    const [carregar, setCarregar] = useState(false);
    const [data, setData] = useState([]);
    const [dateDe, setDateDe] = useSessionStorageState("aprovacaoV360DateDe",format(firstDayOfMonthDate, "yyyy-MM-dd"));
    const [dateAte, setDateAte] = useSessionStorageState("aprovacaoV360DateAte",format(currentDate, "yyyy-MM-dd"));

    const handleDataHora = ({ value }) => {
        if (!value) {
            return "";
        }

        const dataHora = new Date(value);

        if (Number.isNaN(dataHora.getTime())) {
            return value;
        }

        return dataHora.toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    };


    /*
     * Colunas da tabela
     */
    const columns = [
        {
            Header: "Id V360",
            accessor: "IdDocumentoV360"
        },
        {
            Header: "Número",
            accessor: "Numero"
        },
        {
            Header: "Série",
            accessor: "Serie"
        },
        {
            Header: "Usuário",
            accessor: "Usuario"
        },
        {
            Header: "Data/Hora",
            accessor: "DataHora",
            Cell: handleDataHora
        },
        {
            Header: "Status",
            accessor: "Id",
            Cell: (item) => { 
                const { Motivo } = item.row.original;
                const Status = !(Motivo?.trim()) ? 'Aprovado' : 'Reprovado';
                return Status;
            }
        },
        {
            Header: "Motivo",
            accessor: "Motivo"
        }
    ]



    const logAprovacaoV360 = async () => {
        if (!dateDe) {
            ErroMsg("Informe a Data Inicial");
            return;
        }

        if (!dateAte) {
            ErroMsg("Informe a Data Final");
            return;
        }

        if (new Date(dateDe) > new Date(dateAte)) {
            ErroMsg("A Data Inicial não pode ser maior que a Data Final");
            return;
        }

        setCarregar(true);

        const params = new URLSearchParams({
            dateDe,
            dateAte
        });

        const url = `v360/aprovacao-v360?${params}`;

        const retConsulta = await ConsultaAPI_URL(url);

        if (retConsulta?.data.length > 0){
            setData(retConsulta.data);
        }

        setCarregar(false);
    };


    useEffect(() => {
        logAprovacaoV360();
    }, []);


    const excelHeaders = useMemo(() => {
        return columns.map(
            column => column.Header
        );
    }, [columns]);


    const excelRows = useMemo(() => {
        return data.map(item =>
            columns.map(column => {
                const value = item[column.accessor];

                if (column.Cell) {
                    return column.Cell({
                        value,
                        row: {
                            original: item
                        }
                    });
                }

                return value ?? "";
            })
        );
    }, [data, columns]);


    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar} />

                <Col md="12" xs="12">
                    <TitlePage text="Aprovações V360" />
                </Col>
            </Row>


            <Row>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Data Inicial"
                        tipo="date"
                        value={dateDe}
                        onChange={(e) =>
                            setDateDe(e.target.value)
                        }
                    />
                </Col>

                <Col md="3" xs="12">
                    <InputGeral
                        label="Data Final"
                        tipo="date"
                        value={dateAte}
                        onChange={(e) =>
                            setDateAte(e.target.value)
                        }
                    />
                </Col>

            </Row>


            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button
                        variant="outline-primary"
                        type="button"
                        onClick={logAprovacaoV360}
                        className="w-100"
                    >
                        Buscar
                    </Button>
                </Col>


                <Col md="3" xs="12">
                    <ExportarExcel
                        nomeArquivo="Aprovacoes_V360"
                        headers={excelHeaders}
                        rows={excelRows}
                    />
                </Col>
            </Row>


            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable
                        columns={columns}
                        data={data}
                        buttons={[]}
                        paginacao={100}
						linhaCondicional={(item) => (item.Motivo?.trim())}
                    />
                </Col>
            </Row>
        </>
    );
}


export default LogAprovacaoV360;